import { Theme, alpha } from "@mui/material/styles";

import { colors } from "@/theme";

/**
 * The look every modal on the site shares, in one place.
 *
 * It was written inline in the global dialog host, so the confirm dialogs -
 * which are their own `<Dialog>` - came up in the plain MUI panel instead,
 * off-palette next to the page that opened them.
 */
export const dialogPaperSurface = (theme: Theme) => ({
  minWidth: "20rem",
  backgroundImage: "none",
  backgroundColor: theme.palette.background.paper,
  borderRadius: "16px",
  // A hairline in the brand blue and its light under the panel, so a modal
  // is lifted off the page it covers rather than cut out of it.
  borderColor: alpha(colors.prime, 0.28),
  boxShadow: `0 24px 60px rgba(0, 0, 0, 0.45), 0 0 0 1px ${alpha(colors.prime, 0.08)}`,
  // It rises into place. MUI fades the whole dialog in; this is the panel's
  // own short move inside that fade.
  animation: "dialog-rise 240ms cubic-bezier(0.2, 0.8, 0.2, 1)",
  "@keyframes dialog-rise": {
    from: { transform: "translateY(14px) scale(0.98)" },
    to: { transform: "none" },
  },
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
});

/**
 * The page behind is dimmed in the mascot's night navy and put out of focus,
 * so what is in front is the only thing to read.
 */
export const DIALOG_BACKDROP_SX = {
  backgroundColor: "rgba(4, 8, 19, 0.62)",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)",
} as const;
